<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton bg-transparent" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <h1 class="main-header-title">{{ pageTitle }}</h1>
        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->

        <vs-spacer />

        <!-- <search-bar class="mr-4" /> -->

        <notification-drop-down />
    
        <div class="profile-wrapper flex justify-end">
          <profile-drop-down />
        </div>

      </vs-navbar>
    </div>
  </div>
</template>


<script>
// import Bookmarks            from './components/Bookmarks.vue'
// import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    // Bookmarks,
    // SearchBar,
    NotificationDropDown,
    ProfileDropDown
  },
  computed: {
    pageTitle () {
      return this.$route.name
    },
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#ffffff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .vx-navbar.navbar-custom {
    box-shadow: none;
    border-radius: 0;
    padding: 12px 12px 12px 0 !important;
    border-bottom: 1px solid #24435733;
    @media (min-width: 768px) {
      margin: 0rem 0 1rem;
    }
  }
  .main-header-title {
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    padding: 4px 12px 20px;
    margin-bottom: -20px;
    display: block;
    text-transform: uppercase;
    border-bottom: 1px solid #244357;
    @media (min-width: 768px) {
      font-size: 22px;
      margin-bottom: -18px;
    }
  }

  .profile-wrapper {
    @media (min-width: 576px){
      width: 210px;
    }
  }
</style>